import React from "react";
import ReactDOM from "react-dom";
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { ForwardMessageProvider } from "./context/ForwardingMessage/ForwardingMessageContext";
import { EditingMessageProvider } from "./context/EditingMessage/EditingMessageContext";

import App from "./App";

ReactDOM.render(
	<ForwardMessageProvider>
		<EditingMessageProvider>
			{/* CssBaseline fica dentro do ThemeProvider do App (body segue o tema) */}
			<App />
		</EditingMessageProvider>
	</ForwardMessageProvider>,
	document.getElementById("root")
);

// ReactDOM.render(
// 	<React.StrictMode>
// 		<CssBaseline>
// 			<App />
// 		</CssBaseline>,
//   </React.StrictMode>

// 	document.getElementById("root")
// );
